import React from 'react'
import { FieldSet, Label, FloatingLabelInput } from 'ui/acro'
import { Button } from 'ui/bend'
import styled from 'styled-components'
import { Flex } from 'ui/acro'
import Text from 'ui/acro/typography/Text'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import StyledLink from 'components_v2/CommonComponents/StyledLink'
import AccountLocationError from '../common/AccountLocationError'

const Container = styled(Flex)({
  flexDirection: 'column',
  gap: '16px',
  padding: '48px',
  '@media (max-width: 640px)': {
    padding: '48px 20px 24px'
  }
})
const TitleText = styled(Flex)({
  color: '#000',
  fontFamily: 'Proxima-Nova',
  fontSize: '24px',
  fontWeight: 600,
  lineHeight: '32px',
  textTransform: 'uppercase',
  justifyContent: 'center',
  textAlign: 'center'
})

const DescriptionText = styled(Text)({
  color: '#3B3B3B',
  fontFamily: 'Proxima-Nova',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.352px'
})

const ResetBtn = styled(Button)({
  fontFamily: 'Proxima-Nova',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '24px',
  letterSpacing: '0.48px',
  textTransform: 'uppercase',
  padding: '12px 32px',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'stretch',
  color: '#fff',
  background: '#000',
  marginTop: '24px'
})

const BottomLinks = styled(Flex)({
  flexDirection: 'column',
  marginTop: '8px'
})

const schema = Yup.object().shape({
  email: Yup.string()
    .required('Email is required')
    .email('Invalid email format')
})

const Link = styled('a')(() => ({
  color: '#000',
  fontFamily: 'Proxima-Nova',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '0.308px',
  textDecoration: 'underline !important',
  '&:visited': {
    color: '#000',
    textDecoration: 'underline !important'
  },
  '&:focus': {
    color: '#000',
    textDecoration: 'underline !important'
  }
}))

const ForgotPasswordStep1 = ({
  fromPage,
  isSubmitting,
  invalidEmail,
  resetPassword
}) => {
  return (
    <Container>
      <TitleText>
        {fromPage === 'verify' ? 'Verify' : 'Sign in'} With One-time passcode
      </TitleText>
      <DescriptionText>
        Please enter the email address associated with your account to receive a
        one-time passcode.
      </DescriptionText>
      <Formik
        validationSchema={schema}
        initialValues={{ email: '' }}
        onSubmit={resetPassword}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit
        }) => (
          <Form onSubmit={handleSubmit}>
            <FieldSet>
              {invalidEmail && (
                <AccountLocationError>{invalidEmail}</AccountLocationError>
              )}
              <Label>
                <FloatingLabelInput
                  type='email'
                  name='email'
                  handleChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email}
                  errors={errors}
                  touched={touched}
                  className={touched.email && errors.email && 'error'}
                  placeHolder='Email Address'
                  isLabelRequired={false}
                />
              </Label>
            </FieldSet>

            <ResetBtn
              type='submit'
              width='100%'
              mt='32px'
              disabled={(errors.email && true) || !values || values.length <= 0}
              processing={isSubmitting}
              id='alo_reset_pwd_button'
            >
              Get Passcode
            </ResetBtn>
          </Form>
        )}
      </Formik>
      <BottomLinks>
        <StyledLink>
          Having trouble?{' '}
          <Link
            style={{ textDecoration: 'underline' }}
            href='/contact-us'
            target='_blank'
          >
            Contact Us
          </Link>
        </StyledLink>
      </BottomLinks>
    </Container>
  )
}

export default ForgotPasswordStep1
